import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Table } from '../../atoms';
export const SortControllerContext = React.createContext({
    state: { currentSort: { sortKey: '' }, latestKey: '' },
    dispatch: () => null,
});
const initialSortControllerState = { currentSort: { sortKey: '' }, latestKey: null };
const sortControllerReducer = (state, sortKey) => (Object.assign(Object.assign({}, state), { latestKey: sortKey }));
export const Grid = props => {
    const [state, dispatch] = React.useReducer(sortControllerReducer, props.currentSort ? Object.assign(Object.assign({}, initialSortControllerState), { currentSort: props.currentSort }) : initialSortControllerState);
    React.useEffect(() => {
        if (props.onSort && state.latestKey)
            props.onSort(state.latestKey);
    }, [state.latestKey]);
    React.useEffect(() => {
        dispatch(null);
    }, [props.currentSort]);
    return (_jsx(SortControllerContext.Provider, Object.assign({ value: {
            state: Object.assign(Object.assign({}, initialSortControllerState), { currentSort: props.currentSort ? props.currentSort : { sortKey: '' } }),
            dispatch: dispatch,
        } }, { children: props.noTable ? (_jsx(_Fragment, { children: props.children })) : (_jsx(Table, Object.assign({ id: props.id, className: props.className, nonHover: props.nonHover, bottomRounded: props.bottomRounded, layoutFixed: props.layoutFixed }, { children: props.children }))) })));
};
